"use strict";
var javaParser = require("java-parser");
function parse(text, parsers, opts) {
    var cst = javaParser.parse(text, opts.entrypoint);
    return cst;
}
module.exports = parse;
